import { Utilities } from '@spectorasoftware/homegauge-services';
import Vue from 'vue';
import Vuex from 'vuex';

import VueUnleash from 'vue-unleash';
import Actions from './actions';
import Getters from './getters';
import Mutations from './mutations';
import PersistenceLayer from './persistence-layer';
import State from './state';
import Appointment from './modules/appointment';
import Company from './modules/company';
import Person from './modules/person';
import Auth from './modules/auth';
import Schedule from './modules/schedule';
import Services from './modules/services';

Vue.use(Vuex);

const storePlugins = [];

const storageEngineMode = Utilities.StorageDriverLoader.getAvailableStorageDriver();
const acceptedStorageEngineModes = [2, 3];
if (acceptedStorageEngineModes.includes(storageEngineMode)) {
  const persistencePlugin = PersistenceLayer();
  storePlugins.push(persistencePlugin.plugin);
}

const store = new Vuex.Store({
  actions: Actions,
  getters: Getters,
  modules: {
    Appointment,
    Auth,
    Company,
    Person,
    Schedule,
    Services,
  },
  mutations: Mutations,
  plugins: storePlugins,
  state: State,
});

Vue.use(VueUnleash, {
  // Required, Unleash instance host
  host: process.env.VUE_APP_UNLEASH_URL,
  // Required
  store,
});

export default store;
